

import React, { useState } from 'react';
import {
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    Divider,
    Tooltip,
    useTheme
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { Link } from "react-router-dom";
import { IconMap } from './IconMap';
import { useSelector } from 'react-redux';


export const SideBar = ({ menuItems, handleOut }) => {

    const theme = useTheme()
    const [open, setOpen] = useState(false);
    const logged = useSelector(state => state.loggedStore.value)

    const toggleDrawer = () => setOpen(!open);
    const firstCapital = (str) => str[0].toUpperCase() + str.slice(1)

    return (
        <Drawer
            variant="permanent"
            open={open}
            sx={{
                width: open ? 240 : 64,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: open ? 240 : 64,
                    transition: 'width 0.3s',
                    overflowX: 'hidden',
                    boxSizing: 'border-box'
                }
            }}
        >
            <IconButton onClick={toggleDrawer} sx={{ m: 1, width: 'max-content', alignSelf: 'center' }}>
                {open ? <KeyboardDoubleArrowLeftIcon /> : <MenuIcon />}
            </IconButton>
            <Divider />
            <List >
                {
                    menuItems.map((label, index) => (
                        <ListItem
                            key={index}
                            button
                            component={Link}
                            to={`/${label.replace(/\s+/g, '')}`}
                            sx={{ 
                                color: theme.palette.text.primary, 
                                marginBlock: '1.5vh',
                                width: '40vw',
                            }}
                        >
                            <Tooltip title={label} placement="right" disableHoverListener={open}>
                                <ListItemIcon sx={{ paddingBlock: '0.5vh'}}>{IconMap[label]}</ListItemIcon>
                            </Tooltip>
                            {
                                open &&
                                <ListItemText primary={firstCapital(label)} onClick={toggleDrawer} />
                            }
                        </ListItem>
                    ))
                }

                {
                    logged.state &&
                    <ListItem
                        button
                        sx={{ color: theme.palette.text.primary, cursor: 'pointer' }}
                        onClick={() => { handleOut(); toggleDrawer() }}
                    >
                        <Tooltip title={'salir'} placement="right" disableHoverListener={open}>
                            <ListItemIcon>{IconMap['salir']}</ListItemIcon>
                        </Tooltip>
                        {open && <ListItemText primary={firstCapital('salir')} />}
                    </ListItem>
                }
            </List>
        </Drawer>
    );
};
